import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RoutesMap, TOP_BANNER_PADDING, MARKET_HOME_CHAT_PATH } from 'src/utils/const';
import { MarketDashboard } from '../Dashboards/Market';
import { Login } from 'src/App/Dashboards/Market/Pages/Features/Auth/Login';
import { Register } from 'src/App/Dashboards/Market/Pages/Features/Auth/Register';
import { ProtectedRoute } from './ProtectedRoute';
import { IBAS } from '../Dashboards/Admin/Tools/IBAS';
import ActiveMarkets from '../Dashboards/Admin/Pages/ActiveMarkets';
import { ErrorPage, ResetPassword, ResetPasswordConfirmation } from 'src/App/Dashboards/Market/Pages';
import CreateBigMarket from '../Dashboards/Admin/Tools/createBigMarkets';
import { BigMarkets, SingleBigMarkets } from '../Dashboards/Admin/Pages/BigMarkets';
import { useTheme } from '@material-ui/core';
import { useMediaQuery } from '@mui/material';
import { getBannerHeight } from 'src/utils/functions';
import Admin from '../Dashboards/Admin/Pages/Admin';
import AffiliatePartner from '../Dashboards/Admin/Pages/AffiliatePartner';
import ApiCallsTracker from '../Dashboards/Admin/Pages/ApiCallsTracker';
import CustomDataExportTool from '../Dashboards/Admin/Tools/CustomDataExportTool';
import AffliateDashboard from '../Dashboards/Admin/Pages/Affliate/AffliateDashboard';
import ApiDashboard from '../Dashboards/Api/ApiDashboard';

const Routes = () => {
  const theme = useTheme();
  const isMobileBreakPointBanner = useMediaQuery(theme.breakpoints.down(630));
  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);

  return (
    <>
      <div style={{ marginTop: isTopBannerOpen ? getBannerHeight(isMobileBreakPointBanner) : 0 }}>
        <Switch>
          {/* page routes */}
          <Route exact path={RoutesMap.Home} component={MarketDashboard} />
          <Route path={RoutesMap.Pricing} component={MarketDashboard} />
          <Route path={RoutesMap.Login} component={Login} />
          <Route path={RoutesMap.Register} component={Register} />
          <Route exact path={RoutesMap.Data} component={MarketDashboard} />
          {/* <Route path={RoutesMap.OverviewLandingPage} component={MarketDashboard} /> */}
          <Route exact path={RoutesMap.IndividualListing} component={MarketDashboard} />
          <Route exact path={RoutesMap.IndividualHost} component={MarketDashboard} />
          <Route exact path={MARKET_HOME_CHAT_PATH} component={MarketDashboard} />
          <Route path={RoutesMap.Data + '/:country/:city/:district'} component={MarketDashboard} />
          <Route path={RoutesMap.Data + '/landing'} component={MarketDashboard} />
          <Route path={RoutesMap.Data + '/submarket/:submarketID'} component={MarketDashboard} />
          <Route path={RoutesMap.User + '/:settings'} component={MarketDashboard} />
          <Route path={RoutesMap.SearchListing} component={MarketDashboard} />

          <Route exact path={RoutesMap.Calculator} component={MarketDashboard} />
          <Route
            path={[
              RoutesMap.Calculator + '/:locationSlug/:reportId',
              RoutesMap.Calculator + '//:reportId',
            ]}
            component={MarketDashboard}
          />
          <Route path={RoutesMap.Calculator + '/:reportId'} component={MarketDashboard} />
          <Route path={RoutesMap.Discovery + '/compare'} component={MarketDashboard} />
          {/* <Route path={RoutesMap.Discovery} component={MarketDashboard} /> */}
          <Route path={RoutesMap.MyAnalysis} component={MarketDashboard} />
          <Route path={RoutesMap.AdvancedDashboard} component={MarketDashboard} />
          <Route exact path={RoutesMap.Affiliate} component={AffliateDashboard} />
          <ProtectedRoute
            exact
            path={RoutesMap.Affiliate + '/:partnerKey'}
            component={AffliateDashboard}
          />
          <ProtectedRoute
            exact
            path={RoutesMap.Partner + '/:partnerKey'}
            component={AffiliatePartner}
          />
          <ProtectedRoute exact path={RoutesMap.Admin} component={Admin} />
          <ProtectedRoute
            exact
            path={RoutesMap.CustomDataExportTool}
            component={CustomDataExportTool}
          />
          <ProtectedRoute exact path={RoutesMap.ApiCallsTracker} component={ApiCallsTracker} />
          <ProtectedRoute exact path={RoutesMap.IBAS} component={IBAS} />
          <ProtectedRoute exact path={RoutesMap.ActiveMarkets} component={ActiveMarkets} />
          <ProtectedRoute exact path={RoutesMap.CreateBigMarket} component={CreateBigMarket} />
          <ProtectedRoute exact path={RoutesMap.GetBigMarkets} component={BigMarkets} />
          <ProtectedRoute
            exact
            path={RoutesMap.GetBigMarkets + '/:marketName'}
            component={SingleBigMarkets}
          />

          {/* API Routes */}
          <ProtectedRoute exact path={RoutesMap.ApiDashboard} component={ApiDashboard} />

          {/* Password Reset Route */}
          <Route exact path={RoutesMap.ResetPassword} component={ResetPassword} />
          <Route
            exact
            path={RoutesMap.ResetPassword + '/:resetLink'}
            component={ResetPasswordConfirmation}
          />

          {/* modal routes */}
          <Route path={RoutesMap.TailoredRegion + '/:isTailored'} component={MarketDashboard} />

          {/* fallback routes */}
          <Route path={RoutesMap.Error} component={ErrorPage} />
          <Redirect to={MARKET_HOME_CHAT_PATH} />
        </Switch>
      </div>
    </>
  );
};

export default Routes;
